import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountFormsComponent } from './components/account-forms/account-forms.component';
import { ChangePasswordFormComponent } from './components/change-password-form/change-password-form.component';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';

const accountRoutes: Routes = [
  /*
    Currently the login is a little bit simplistic, longer term there should probably be 
    parent/child routes managing the "AccountFormsComponent" vs "LoginComponent", "ResetPassword"
    and whatever else we might want. 
  */
  {
    path: 'login',
    component: AccountFormsComponent,
  },
  {
    path: 'authenticateemail',
    component: AccountFormsComponent,
  },
  {
    path: 'remoteorghostlogin',
    component: AccountFormsComponent,
  },
  {
    path: 'mobilelogin',
    component: AccountFormsComponent,
  },
  {
    path: 'singlesignon',
    component: AccountFormsComponent,
  },
  {
    path: 'resetpassword',
    component: ResetPasswordComponent,
    data: { i18nTitle: 'AccountController_ResetPassword' },
  },
  {
    path: 'changepassword',
    component: ChangePasswordFormComponent,
    data: { i18nTitle: 'AccountController_ChangePasswordTitle' },
  },
];
@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forChild(accountRoutes)],
  exports: [RouterModule],
})
export class AccountRoutingModule {}
